(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-encargo"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('DOMContentLoaded', () => {
    const btn = document.getElementById('bc-ei-filter-btn');
    const drawer = document.getElementById('bc-ei-drawer');
    const backdrop = document.getElementById('bc-ei-backdrop');
    const closeBtn = document.getElementById('bc-ei-drawer-close');
    function openDrawer() {
      if (!drawer || !backdrop) return;
      drawer.style.transform = 'translateX(0)';
      backdrop.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      if (!drawer || !backdrop) return;
      drawer.style.transform = 'translateX(100%)';
      backdrop.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    if (btn) btn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (backdrop) backdrop.addEventListener('click', closeDrawer);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-stock-inmediato"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('DOMContentLoaded', () => {
    const btn = document.getElementById('bc-si-filter-btn');
    const drawer = document.getElementById('bc-si-drawer');
    const backdrop = document.getElementById('bc-si-backdrop');
    const closeBtn = document.getElementById('bc-si-drawer-close');
    function openDrawer() {
      if (!drawer || !backdrop) return;
      drawer.style.transform = 'translateX(0)';
      backdrop.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      if (!drawer || !backdrop) return;
      drawer.style.transform = 'translateX(100%)';
      backdrop.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    if (btn) btn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (backdrop) backdrop.addEventListener('click', closeDrawer);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
